import React, { Component } from 'react'
import Button from 'component/Button/index'
import PropTypes from 'prop-types'
import NewSectionBlockForm from 'component/sectionBlock/NewSectionBlockForm'
import Modal from '../Modal'

const TREE_LEVELS = {
  sections: 2,
  subsections: 3,
  types: 4,
  subtypes: 5,
}

class SectionBlockFormModal extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    values: PropTypes.object,
    options: PropTypes.object,
  }

  static defaultProps = {
    initialValues: {
      sectionId: [],
      subSectionId: [],
      typeId: [],
      subTypeId: [],
    },
  }

  state = {
    stores: [],
    sections: [],
    subsections: [],
    types: [],
    subtypes: [],
  }

  disableSubmitButton = () =>
    !Object.values(this.state).some((section) => section.length)

  getParameterObject = (idKey, level, parameters, values) =>
    values
      .map((i) => {
        const foundObj = parameters.find((item) => +item[idKey] === +i)
        if (foundObj) {
          return {
            ...foundObj,
            level,
          }
        }
        return null
      })
      .filter((e) => e)

  filterLevels = (parameters, values) => {
    const subtypes = this.getParameterObject(
      'subTypeId',
      TREE_LEVELS.subtypes,
      parameters.subtypes,
      values.subtypes
    )
    const initialTypes = this.getParameterObject(
      'typeId',
      TREE_LEVELS.types,
      parameters.types,
      values.types
    )
    const initialSubsections = this.getParameterObject(
      'subSectionId',
      TREE_LEVELS.subsections,
      parameters.subsections,
      values.subsections
    )
    const initialSections = this.getParameterObject(
      'sectionId',
      TREE_LEVELS.sections,
      parameters.sections,
      values.sections
    )

    const types = initialTypes.filter(
      (item) => !subtypes.some((subItem) => subItem.typeId === item.typeId)
    )

    const subsections = initialSubsections.filter(
      (item) =>
        !initialTypes.some(
          (subItem) => subItem.subSectionId === item.subSectionId
        )
    )

    const sections = initialSections.filter(
      (item) =>
        !initialSubsections.some(
          (subItem) => subItem.sectionId === item.sectionId
        )
    )

    return [...sections, ...subsections, ...types, ...subtypes]
  }

  clear = (callback) => {
    this.setState(
      {
        values: {
          stores: [],
          sections: [],
          subsections: [],
          types: [],
          subtypes: [],
        },
      },
      callback
    )
  }

  submit = () => {
    const { values, parameters } = this.state
    const { handleSubmit } = this.props

    const stores = (values.stores || []).map((v) => String(v).padStart(4, '0'))

    this.clear(() => {
      handleSubmit &&
        handleSubmit(stores, this.filterLevels(parameters || {}, values || {}))
    })
  }

  render() {
    const { values = {} } = this.state
    const { translate, options } = this.props

    return (
      <Modal
        title={translate('mobile.punctual.adjust.sectionBlock.newBlock')}
        disabledBgClickClosing
        size='md'
        renderButton={({ onClick }) => (
          <Button
            className='btn btn-primary margin-right'
            text={translate('mobile.punctual.adjust.sectionBlock.newBlock')}
            onClick={onClick}
          />
        )}
        cancelButtonText={translate('close_button_label')}
        confirmButtonText={'Cadastrar'}
        isConfirmButtonDisabled={
          (values.sections || []).length === 0 ||
          (values.stores || []).length === 0
        }
        onConfirm={this.submit}
        onCloseModal={() => this.clear()}
        disableMaxHeight
      >
        <NewSectionBlockForm
          storeList={options.stores || []}
          options={options}
          onChange={(vl, parameters) =>
            this.setState({ values: vl, parameters })
          }
          excludeInactive={true}
        />
      </Modal>
    )
  }
}

export default SectionBlockFormModal

export { SectionBlockFormModal }
